/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RecordingManualChangesResponseFieldsContributionsItemsInnerChangesDataCategory
 */
export interface RecordingManualChangesResponseFieldsContributionsItemsInnerChangesDataCategory {
    /**
     * 
     * @type {object}
     * @memberof RecordingManualChangesResponseFieldsContributionsItemsInnerChangesDataCategory
     */
    value: object | null;
}

/**
 * Check if a given object implements the RecordingManualChangesResponseFieldsContributionsItemsInnerChangesDataCategory interface.
 */
export function instanceOfRecordingManualChangesResponseFieldsContributionsItemsInnerChangesDataCategory(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "value" in value;

    return isInstance;
}

export function RecordingManualChangesResponseFieldsContributionsItemsInnerChangesDataCategoryFromJSON(json: any): RecordingManualChangesResponseFieldsContributionsItemsInnerChangesDataCategory {
    return RecordingManualChangesResponseFieldsContributionsItemsInnerChangesDataCategoryFromJSONTyped(json, false);
}

export function RecordingManualChangesResponseFieldsContributionsItemsInnerChangesDataCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecordingManualChangesResponseFieldsContributionsItemsInnerChangesDataCategory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': json['value'],
    };
}

export function RecordingManualChangesResponseFieldsContributionsItemsInnerChangesDataCategoryToJSON(value?: RecordingManualChangesResponseFieldsContributionsItemsInnerChangesDataCategory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
    };
}

